import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import TagManager from 'react-gtm-module'
import { toast } from 'react-toastify'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import Skeleton from 'react-loading-skeleton'
import { formatFileSize, toTitleCase } from '../../../../core/_util'
import EditMetaDataModal from './EditMetaDataModal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { RequestFileStatusModal } from '../RequestFileStatusModal'
import { RequestAccessModal } from '../RequestAccessModal'
import { checkRole } from '../../core/_requests'
import { useAuth } from '../../../auth'
import { useDateFormat } from '../../../../hooks/useDateFormat'
import { docFrequencyOptions } from '../../core/_constants'
import { getQuarterMonths } from '../../core/_util'
// import Edit from '../../../../../media/shared-access/edit.svg'
// import FileProcessingFailed from '../../views/FilePricessingFailed'

const MetaData = ({
  metaData,
  fileData,
  metadataLoading,
  getAllMetaData,
  documentName,
}: {
  metaData: any
  fileData: any
  metadataLoading: boolean
  getAllMetaData: (recordId: string) => void
  documentName: string
}) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  // State for Read More functionality
  const [isExpanded, setIsExpanded] = useState(false)
  const [isModalActive, setIsModalActive] = useState(false)
  const [modalContainer, setModalContainer] = useState<HTMLElement | null>(null)
  const [showAccessModal, setShowAccessModal] = useState<boolean>(false)
  const [showFileStatusModal, setFileStatusModal] = useState<boolean>(false)
  const [action, setAction] = useState('')
  const { getDateValue } = useDateFormat()
  const [roleCheckValidatorLoader, setRoleCheckValidatorLoader] = useState<boolean>(false)
  function handleCopy(event: React.MouseEvent<HTMLImageElement>, textToCopy: string) {
    const linkToCopy = textToCopy || ''
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        toast.success('Text copied to clipboard')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ShareSocialMedia,
            action: 'normal',
            metadata: {
              link: linkToCopy,
              company_id: 'static_company_id',
              user_id: 'static_user_id',
              email: 'static_email@example.com',
            },
          },
        })
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
        toast.error('Failed to copy link')
      })

    event.preventDefault()
  }

  const checkRoleValidate = async (action: string) => {
    setRoleCheckValidatorLoader(true)
    if (!companyId || !fileData.recordId) return
    try {
      const {
        data: { success, data },
      } = await checkRole(fileData.recordId, companyId, action)
      if (success) {
        if (data.editAccess && data.viewAccess && !data.isPending) {
          if (action === 'EDIT') setIsModalActive(true)
        }
        if (data.isPending) setFileStatusModal(true)
        if (data.unAuthorized) setShowAccessModal(true)
        if (data.isRejected) toast.error('Your request has been rejected')
      }
    } catch (err) {
    } finally {
      setRoleCheckValidatorLoader(false)
    }
  }
  // Function to toggle read more
  const toggleExpand = () => {
    setIsExpanded((prev) => !prev)
  }

  return (
    <div className='bg-white p-5 rounded'>
      <div className='d-md-flex justify-content-between align-items-end d-none'>
        <h1 className='w-50 font-size-16 mb-md-6 mb-0'>
          {formatMessage({ id: 'File Information' })}
        </h1>
        <div className='d-flex w-50 justify-content-between align-items-center'>
          <h1 className='w-50 font-size-16 mb-md-6 mb-0'>
            {formatMessage({ id: 'AI-Powered Period Details' })}
          </h1>
          <button
            className='btn bg-primary custom-button-property text-white w-100 w-md-auto my-2 my-md-0'
            onClick={() => {
              setAction('EDIT')
              checkRoleValidate('EDIT')
            }}
            disabled={metadataLoading || roleCheckValidatorLoader}
          >
            {roleCheckValidatorLoader ? (
              <span className='indicator-label font-size-13 p-0'>
                {formatMessage({ id: 'Please wait...' })}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              formatMessage({ id: 'Edit' })
            )}
          </button>
        </div>
      </div>
      <div className='d-flex flex-column d-md-none'>
        <button
          className='btn bg-primary custom-button-property text-white w-100 w-md-auto my-2 my-md-0'
          onClick={() => {
            setAction('EDIT')
            checkRoleValidate('EDIT')
          }}
          disabled={metadataLoading || roleCheckValidatorLoader}
        >
          {roleCheckValidatorLoader ? (
            <span className='indicator-label font-size-13 p-0'>
              {formatMessage({ id: 'Please wait...' })}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          ) : (
            formatMessage({ id: 'Edit' })
          )}
        </button>
      </div>
      {isModalActive && (
        <EditMetaDataModal
          isModalActive={isModalActive}
          setIsModalActive={setIsModalActive}
          metadata={metaData}
          metadataLoading={metadataLoading}
          getAllMetaData={getAllMetaData}
          documentName={documentName}
        />
      )}
      {/* <FileProcessingFailed
        tag='Password Protected'
        title='AI Generated Insight Not Available For This File'
        desc='We couldn’t process this file with AI because its content could not be accessed due to the issue mentioned above.<br>Please review and resolve the listed issue, then try again to generate AI-based insights.'
      /> */}
      <div className='d-md-flex'>
        <h1 className='w-100 font-size-16  d-md-none d-block my-6'>
          {formatMessage({ id: 'File Information' })}
        </h1>
        <div className='w-md-50 w-100'>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {metaData?.version && metaData?.version.indexOf('1.0') === -1
                ? formatMessage({ id: 'Updated File Name' })
                : formatMessage({ id: 'File Name' })}
              <span>
                <ToolTipUI
                  tooltipText={`The title or name identifying this document, which should be descriptive and follow your organization's naming conventions.`}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13 text-wrap'>
                {' '}
                <span ref={(node) => setModalContainer(node)}>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='tooltip'>
                        <p className='m-0'>{metaData?.fileName}</p>
                      </Tooltip>
                    }
                    container={modalContainer}
                  >
                    <p className=' m-0'>
                      {metaData?.fileName.length > 30
                        ? `${metaData?.fileName.substring(0, 30)}...${metaData?.fileName.substring(
                          metaData?.fileName.lastIndexOf('.')
                        )}`
                        : metaData?.fileName}
                    </p>
                  </OverlayTrigger>
                </span>
              </p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Version' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The iteration number of this document, allowing you to track changes and updates over time while maintaining version control.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{metaData?.version}</p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'File Type' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'The technical format of the document (PDF, DOCX, etc.), which determines how it can be accessed and what software can open it.',
                })}
              />
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{metaData?.fileType}</p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Blockchain Verification' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `Confirmation that this document's integrity has been verified using blockchain technology, ensuring it hasn't been tampered with.`,
                })}
              />
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{metaData?.isVerified?.toString()}</p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'File Size' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The storage space this document occupies, important for quota management and understanding resource usage.`,
                })}
              />
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13 text-wrap'>
                {metaData?.sizeInBytes ? `${formatFileSize(metaData.sizeInBytes)} ` : 'N/A'}
              </p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Created By' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The person who initially created or uploaded this document, establishing accountability and authorship.`,
                })}
              />
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{`${fileData?.createdUser?.firstName} ${fileData?.createdUser?.lastName || ''
                }`}</p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Last Modified By' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The person who most recently made changes to this document, important for tracking responsibility for current content.`,
                })}
              />
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{`${fileData?.updatedUser?.firstName} ${fileData?.updatedUser?.lastName}`}</p>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Serial Number' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `A unique identifier assigned to this document within a specific series, often used for invoices and sequential documents.`,
                  })}
                />
              </span>
            </p>
            {/* <p className='w-50 font-size-13'>{formatMessage({ id: 'Invoice Number #123456' })}<i className="fa-regular fa-copy text-dark font-size-13 cursor-pointer"></i></p> */}
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='w-50 font-size-13 d-flex '>
                <span ref={(node) => setModalContainer(node)}>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='tooltip'>
                        <p className='m-0'>{metaData?.serialNumber ?? '-'}</p>
                      </Tooltip>
                    }
                    container={modalContainer}
                  >
                    <div>
                      {metaData?.serialNumber
                        ? metaData?.serialNumber.length > 15
                          ? `${metaData?.serialNumber.substring(0, 15)}...`
                          : metaData?.serialNumber
                        : '-'}
                    </div>
                  </OverlayTrigger>
                </span>

                {metaData?.serialNumber && (
                  <span>
                    <img
                      src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-copy.svg')}
                      alt='copy icon'
                      className='ms-2 cursor-pointer'
                      onClick={(event) => handleCopy(event, metaData?.serialNumber || '')}
                    />
                  </span>
                )}
              </div>
            )}
          </div>
          <div className='d-flex align-items-center'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Document Nature' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The category or type of content this document represents (invoice, contract, etc.), helping with classification and workflow assignment.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex align-items-center gap-1 flex-wrap w-50 mb-4'>
                {metaData?.documentNature
                  ? metaData.documentNature.split(',').map((tag: string, index: number) => (
                    <span key={index} className='p-2 border border-muted rounded font-size-13'>
                      {tag.trim()}
                    </span>
                  ))
                  : '-'}
              </div>
            )}
          </div>
          <div className='d-flex align-items-center'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Tags' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `User-defined labels that categorize this document by department, project, or purpose for enhanced organization and discovery.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex align-items-center gap-1 flex-wrap w-50 mb-4'>
                {metaData?.tags
                  ? metaData.tags.split(',').map((tag: string, index: number) => (
                    <span key={index} className='p-2 border border-muted rounded font-size-13'>
                      {tag.trim()}
                    </span>
                  ))
                  : '-'}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13'>
              {formatMessage({ id: 'Related Country' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The nation or jurisdiction relevant to this document's content, important for compliance with regional regulations.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-2 w-50'>
                <p className='font-size-13 text-wrap'>{metaData?.country || '-'}</p>
                {/* {metaData?.country && <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' />} */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Archival Date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The date when this document should be moved to long-term storage according to your retention policy.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>
                {metaData?.archivalDate ? metaData.archivalDate : '-'}
              </p>
            )}
          </div>
        </div>
        <div className='w-md-50 w-100'>
          {/* <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Year' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'The year the document was created, relevant for tracking its age and compliance with retention policies.',
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <p className='w-50 font-size-13'>{metaData?.year || '-'}</p>
            )}
          </div> */}
          <h1 className='w-100 font-size-16  d-md-none d-block my-6'>
            {formatMessage({ id: 'File Information' })}
          </h1>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The calendar date associated with this document's content or most recent update, helping with chronological organization.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.docDate ? getDateValue(metaData?.docDate) : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Day' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The day of the month when the document was created or last modified, providing additional context for timeline tracking.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>{metaData?.day || '-'}</p>
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Month' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The calendar month associated with this document, useful for periodic reporting and seasonal record organization.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.docDate
                    ? new Date(metaData?.docDate).toLocaleString('default', { month: 'long' })
                    : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Quarter' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The business quarter (in months) relevant to this document, essential for financial and performance reporting periods.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.quarter && metaData?.docDate
                    ? getQuarterMonths(
                      metaData?.quarter,
                      metaData?.finanicalYearSetting,
                      new Date(metaData?.docDate).toLocaleString('default', { month: 'long' })
                    )
                    : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Year' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The calendar year associated with this document, fundamental for annual reporting and long-term record organization.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.docDate ? new Date(metaData?.docDate).getFullYear() : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Signing date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The date when this document was officially signed or approved, critical for contracts and legal documents.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.signingDate ? getDateValue(metaData?.signingDate) : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Expiration date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The date when this document becomes invalid or requires renewal, essential for compliance and document lifecycle management.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.expirationDate ? getDateValue(metaData?.expirationDate) : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Start date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The date when this document or the agreement it represents becomes effective, critical for contract management.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.startDate ? getDateValue(metaData?.startDate) : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'End date' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The date when this document or the agreement it represents ceases to be effective, essential for contract expiration tracking.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.endDate ? getDateValue(metaData?.endDate) : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Frequency' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `How often this document type is generated or updated, useful recurring reporting or filing documents.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.docFrequency
                    ? docFrequencyOptions.find(
                      (option: any) => option.value === metaData?.docFrequency
                    )?.label
                    : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          {/* <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Currency' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The monetary denomination used in financial figures within this document, essential for accurate financial reporting.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>{'USD'}</p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
          {/* </div>
            )}
          </div> */}
          {/* <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Amount' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The financial value associated with this document, critical for budgeting, accounting, and financial analysis.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>{'199'}</p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
          {/* </div> */}
          {/* )} */}
          {/* </div> */}
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Calendar Year' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The standard January-December year period relevant to this document, used for annual planning and reporting.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {' '}
                  {metaData?.docDate ? new Date(metaData?.docDate).getFullYear() : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Financial Year' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The fiscal year period relevant to this document, which may differ from the calendar year depending on your organization.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.financialYear
                    ? metaData.finanicalYearSetting === 'January-December'
                      ? metaData?.financialYear.split('-')[0]
                      : metaData?.financialYear
                    : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
          <div className='d-flex'>
            <p className='w-50 text-muted font-size-13 text-wrap'>
              {formatMessage({ id: 'Assessment Year' })}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `The tax or evaluation period relevant to this document, important for auditing and compliance reporting.`,
                  })}
                />
              </span>
            </p>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex gap-8 w-50'>
                <p className=' font-size-13'>
                  {metaData?.assessmentYear
                    ? metaData.finanicalYearSetting === 'January-December'
                      ? metaData?.assessmentYear
                      : `${metaData?.assessmentYear}-${metaData?.assessmentYear + 1}`
                    : '-'}
                </p>
                {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <h1 className='font-size-16 my-6'>{formatMessage({ id: 'AI-Powered Insights' })}</h1>
      <div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13 text-wrap'>
            {formatMessage({ id: 'Summary' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `An AI-generated condensed version of the document's key points, saving time by highlighting essential information.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            (() => {
              const summary = metaData?.summary || ''
              const shouldTruncate = summary.length > 250
              const displayedText =
                isExpanded || !shouldTruncate ? summary : `${summary.slice(0, 250)}...`

              return (
                <p className='w-md-75 w-100 font-size-13 text-wrap'>
                  {summary ? displayedText : '-'}
                  {shouldTruncate && (
                    <span className='text-primary cursor-pointer' onClick={toggleExpand}>
                      {isExpanded ? ' Read Less' : ' Read More'}
                    </span>
                  )}
                </p>
              )
            })()
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Document Context' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The primary information contained within this document, analyzed by AI to extract key data points and insights.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <p className='w-md-75 w-100 font-size-13 text-wrap'>
              {metaData?.context ? metaData.context : '-'}
            </p>
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Structure Classification' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The organizational framework or template type used in this document, helpful for standardizing similar records.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <p className='w-md-75 w-100 font-size-13 text-wrap'>
              {metaData?.structureClassificationLevelOne.name} {'>'}{' '}
              {metaData?.structureClassificationLevelTwo.name} {'>'}{' '}
              {metaData?.structureClassificationLevelThree.name}
            </p>
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Currency' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The monetary denomination used in financial figures within this document, essential for accurate financial reporting.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex gap-8 w-50'>
              <p className=' font-size-13'>{metaData?.currency ? metaData?.currency : '-'}</p>
              {/* <img src={Edit} alt="edit" width={24} height={24} className='cursor-pointer' /> */}
            </div>
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Amount' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The financial value associated with this document, critical for budgeting, accounting, and financial analysis.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex gap-8 w-50'>
              <p className=' font-size-13'>{metaData?.amount ? metaData?.amount : '-'}</p>
            </div>
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Country' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The geographical location relevant to this document's creation or application, important for jurisdictional compliance.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex gap-8 w-50'>
              <p className=' font-size-13'>{'USA'}</p>
            </div>
          )}
        </div>
        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Keywords' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `AI-identified significant terms within the document that indicate its subject matter and relevance.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <p className='w-md-75 w-100 font-size-13'>
              {' '}
              {metaData?.keywords ? metaData.keywords : '-'}
            </p>
          )}
        </div>

        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Associated Software' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The program used to create this document, important for compatibility and proper viewing.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 mb-4'>
              {metaData?.associatedSoftware ?? '-'}
            </div>
          )}
        </div>

        <div className='d-flex flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Associated Software Version' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The specific version of software used to create this document, ensuring proper rendering and future accessibility.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 mb-4'>
              {metaData?.associatedSoftwareVersion ?? '-'}
            </div>
          )}
        </div>

        <div className='d-flex align-items-md-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Referenced Companies' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `Organizations mentioned within the document content, automatically identified for relationship mapping.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 mb-4'>
              {metaData?.referencedCompanies
                ? metaData.referencedCompanies.split(',').map((tag: string, index: number) => (
                  <span key={index} className=' p-2 border border-muted rounded font-size-13'>
                    {tag.trim()}
                  </span>
                ))
                : '-'}
            </div>
          )}
        </div>
        <div className='d-flex align-items-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Confidentiality Level' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `The security classification indicating who can access this document, critical for information security compliance.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <p className='w-md-75 w-100 font-size-13 text-wrap'>
              {metaData?.confidentialityLevel ? metaData.confidentialityLevel : '-'}
            </p>
          )}
        </div>
        <div className='d-flex align-items-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13'>
            {formatMessage({ id: 'Tags' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `AI-suggested or user-added categorization labels that help organize and quickly locate this document.`,
                })}
              />
            </span>
          </p>
          <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 '>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex align-items-center gap-1 flex-wrap w-50 mb-4'>
                {metaData?.tags
                  ? metaData.tags.split(',').map((tag: string, index: number) => (
                    <span key={index} className='p-2 border border-muted rounded font-size-13'>
                      {tag.trim()}
                    </span>
                  ))
                  : '-'}
              </div>
            )}
          </div>
        </div>
        <div className='d-flex align-items-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13 text-wrap'>
            {`Entities, if any`}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `People, organizations, or legal entities identified within the document content, important for relationship mapping.`,
                })}
              />
            </span>
          </p>

          <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 mb-4'>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex flex-row flex-wrap'>
                {metaData?.persons
                  ? metaData.persons.split(',').map((person: string, index: number) => (
                    <div
                      key={index}
                      className='p-1 border border-muted rounded font-size-13 me-2'
                    >
                      <span>
                        <img
                          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-people.svg')}
                          alt='people'
                          width={14}
                          height={14}
                          className='me-1'
                        />
                      </span>
                      {person.trim()}
                    </div>
                  ))
                  : '-'}
              </div>
            )}
          </div>
        </div>
        <div className='d-flex align-items-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13 text-wrap'>
            {formatMessage({ id: 'Relevant Dates' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `Key timeframes mentioned within the document that may require attention or action, automatically identified.`,
                })}
              />
            </span>
          </p>

          <div className='d-flex align-items-center gap-1 flex-wrap w-md-75 w-100 mb-4'>
            {metadataLoading ? (
              <Skeleton
                width={100}
                height={25}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex flex-row'>
                {metaData?.relevantDates
                  ? metaData.relevantDates.split(',').map((date: string, index: number) => (
                    <div
                      key={index}
                      className='p-1 border border-muted rounded font-size-13 me-2'
                    >
                      <span>
                        <img
                          src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/ic-people.svg')}
                          alt='people'
                          width={14}
                          height={14}
                          className='me-1'
                        />
                      </span>
                      {toTitleCase(date.split(':')[0])}: {getDateValue(date.split(':')[1].trim())}
                    </div>
                  ))
                  : '-'}
              </div>
            )}
          </div>
        </div>
        <div className='d-flex align-items-center flex-md-row flex-column'>
          <p className='w-md-25 w-100 text-muted font-size-13 text-wrap'>
            {formatMessage({ id: 'Compliance Requirements' })}
            <span>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: `Regulatory standards this document must adhere to, ensuring your organization meets legal obligations.`,
                })}
              />
            </span>
          </p>
          {metadataLoading ? (
            <Skeleton
              width={100}
              height={25}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          ) : (
            <ul className='w-md-75 w-100 font-size-13 text-wrap p-0'>
              {metaData?.complianceRequirement
                ? metaData.complianceRequirement.split(';').map((req: string) => <li>{req}</li>)
                : '-'}
            </ul>
          )}
        </div>
      </div>
      <RequestAccessModal
        showAccessModal={showAccessModal}
        setShowAccessModal={setShowAccessModal}
        headingMessage="You don't have access to perform this action"
        description={`Your request will be sent to ${fileData?.createdUser?.email}.You cannot submit another request for 48 hours after submission`}
        recordId={fileData?.recordId}
        action={action}
      />
      <RequestFileStatusModal
        showFileStatusModal={showFileStatusModal}
        setFileStatusModal={setFileStatusModal}
        headingMessage='Rquest is already in process'
        description='Your request is in the queue.Please kindly wait until you recieve a response'
      />
    </div>
  )
}

export default MetaData
